import React from 'react';
import { SdfSelect, SdfxPagination } from '@synerg/react-components';


export default function Pagination({ totalPages, totalCount, pageNumber, itemsPerPage, handlePaginationChange }) {

	const handlePageSizeChange = (size) => {
		handlePaginationChange(totalPages, totalCount, 1, size);
	}

	const handlePageNumberChange = (pageNo) => {
		handlePaginationChange(totalPages, totalCount, pageNo, itemsPerPage);
	}

	const start = totalCount > 0 ? (pageNumber - 1) * itemsPerPage + 1 : 0;
	const end = (pageNumber * itemsPerPage) > totalCount ? totalCount : (pageNumber * itemsPerPage);

	const PAGE_SIZES = [{ label: '50', value: 50 }, { label: '100', value: 100 }];

	return (<>
		<div className="flex items-center justify-end">
			<div className="text-sm text-action-default">Rows per page:</div>
			<SdfSelect
			portalEnabled={'true'}
			label="rows per page"
            hideLabel={true}
			className="w-20 text-sm text-action-default px-4 mb-1 border-r-1 border-t-0 border-l-0 border-b-0 border-dark border-solid"
			items={[...PAGE_SIZES]}
			onSdfChange={({ detail }) => {
				handlePageSizeChange(detail.value);
			}}
			value={{ label: `${itemsPerPage}`, value: itemsPerPage }}
			/>
			<div className="text-sm text-action-default px-4">{`${start} - ${end} items`}</div>
			<SdfxPagination
			currentPage={pageNumber}
			totalPages={totalPages}
			onSdfxPageChange={({ detail }) => {
				handlePageNumberChange(detail);
			}}
			/>
		</div>
	</>
	)
}
